import 'slick-slider';
import jQueryBridget from 'jquery-bridget';
import Masonry from 'masonry-layout';
var imagesLoaded = require('imagesloaded');
import InfiniteScroll from 'infinite-scroll';
//import { json } from 'modernizr';

var gb = {
    isMobile: (navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i)) ? true : false,
    isPhone: (navigator.userAgent.match(/Android|BlackBerry|iPhone|iPod|Opera Mini|IEMobile/i)) ? true : false,
    isMoz: (navigator.userAgent.match(/Firefox/i)) ? true : false,
    masonryOpt: {itemSelector: '.grid-item', columnWidth: '.grid-sizer', gutter: '.gutter-sizer', percentPosition: true},
    mapInitialized: false,
    videoInitiated: false,
    pageObserver: new Object(),
    init: function() {
        var _this = this;
        if (this.isMobile) {
            $("body").addClass("isMobile");
        }
        this.initNav();
        Foundation.addToJquery($);
        $(document).foundation();

        this.initSlickSlider(".slickme");
        this.initInterchange();
        this.initHP();
        this.initIntersectionObserver();
        this.initAccordion();
        this.formValidation();
        this.initMasonry();
        this.initFancybox();
        this.util();
        this.initMagellanMenu();
        this.initMagellanGallery();
        this.initArrows();
        this.initEventTracking();
        this.initTripMenu();
        this.showGear();
        window.onhashchange = function () {
            _this.pageJump();
        };
        this.pageJump();
        this.createModal();
        this.globalStuff();
        this.manageAcc();
        this.checkModal
    },
    initSlickSlider: function(sel) {
        $(sel).slick({
            responsive: [
                {
                  breakpoint: 640,
                  settings: {
                    arrows: true
                  }
                },
                {
                  breakpoint: 639,
                  settings: {
                    arrows: false
                  }
                }
            ]
        });
    },
    initHP: function() {
        var vid = document.getElementById("rjvid"), jVid = $(vid),
            vidBanner = $(".vid-banner").first();

        if (vidBanner.length) {
            var $w = $(window),
                vidHeight = vidBanner.offset().top + vidBanner.innerHeight(),
                _this = this;

            $("#rj-promo").on("init", function() {
                if (!_this.videoInitiated && vidBanner.hasClass("slick-active")) {
                    _this.initHPVid(vid, jVid);
                    _this.videoInitiated = true;
                }
                vidHeight = vidBanner.offset().top + vidBanner.innerHeight();
            }).on("beforeChange", function(event, slick, currentSlide, nextSlide) {
                //console.log("=====> beforeChange, banner active:", $(slick.$slides.get(nextSlide)).is(vidBanner));
                if (!_this.videoInitiated) {
                    if ($(slick.$slides.get(nextSlide)).is(vidBanner)) {
                        _this.initHPVid(vid, jVid);
                        _this.videoInitiated = true;
                    }
                } else {
                    $(slick.$slides.get(nextSlide)).is(vidBanner) ? vid.play() : vid.pause();
                }
            });
        }
        this.initSlickSlider("#rj-promo");
        
        $("#covid-msg-more").on("click touchend", function(e) {
            e.preventDefault();
            $("#covid-msg").removeClass("hp");
        });
    },
    initHPVid: function(vid, jVid) {
        jVid.append('<source src="/assets/videos/TCO_bikepacking_clip.mp4" type="video/mp4">');

        jVid.on("stopMe", function() {
            vid.pause();
        }).on("startMe", function() {
            vid.play();
        });
    },
    playHPVid: function(elm) {
        $(elm).trigger("startMe");
    },
    pauseHPVid: function(elm) {
        $(elm).trigger("stopMe");
    },
    loadRJVid: function(elm) {
        if (!this.videoInitiated) {
            this.initHPVid(elm, $(elm));
            this.videoInitiated = true;
        }
        this.playHPVid(elm);
    },
    initIntersectionObserver: function() {
        var _this = this;
        var options = {
            rootMargin: '0px 0px 200px 0px',
            threshold: 0
        };

        if ("IntersectionObserver" in window) {
            _this.pageObserver = new IntersectionObserver(function(els, observer) {
                els.forEach(function(el) {
                    var elm = el.target;
                    var cbo = elm.dataset.callbackOutside;

                    if (el.isIntersecting) {
                        var cb = elm.dataset.callback;
                        if (cb) {
                            try {
                                _this[cb](elm);
                            } catch(err) {
                                console.log("Callback failed");
                            };
                        };
                        if (!cbo) {
                            observer.unobserve(elm);
                        }
                    } else {
                        if (cbo) {
                            try {
                                _this[cbo](elm);
                            } catch(err) {
                                console.log("Callback failed");
                            };
                        }
                    }
                });
            }, options);

            $("[data-intersection]").each(function() {
                _this.pageObserver.observe(this);
            });
        } else {
            $("[data-intersection]").each(function() {
                var cb = $(this).attr("data-callback");
                if (cb) {
                    try {
                        _this[cb + "Failover"](this);
                    } catch(err) {
                        _this[cb](this);
                    };
                }
            });
        };
    },
    initRotatingImgs: function() {
        var imgRotator = $("#image-rotator");

        if (imgRotator.length) {
            $.get("/ajax/image_rotator.php", function(data) {
                if (data) {
                    var link = "/surly-bicycles-and-frames";
                    $.each(JSON.parse(data), function(index, value) {
                        var slideImg = '<a href="' + link + '"><img src="' + value[0] + '" alt="' + value[1] + '" /></a>';
                        imgRotator.append(slideImg);
                    });
                    var iRotator = imgRotator.slick({
                        autoplay: true,
                        infinite: true,
                        autoplaySpeed: 2500,
                        arrows: false,
                        speed: 1000,
                        fade: false,
                        pauseOnFocus: false,
                        pauseOnHover: false
                    });

                    var vidControl = '<a href="#" class="vid-control pause">' +
                        '<span class="sr-only" data-pause="Pause slider" data-play="Play slide">Pause slide</span>' +
                        '</a>';
                    $("#image-rotator-wrapper").append(vidControl).on("click", ".vid-control", function(e) {
                        e.preventDefault();
                        var textNode = $(this).find(".sr-only");
                        if ($(this).hasClass("pause")) {
                            iRotator.slick("slickPause");
                            $(this).removeClass("pause").addClass("icon-play");
                            textNode.text(textNode.data("play"));
                        } else if ($(this).hasClass("icon-play")) {
                            iRotator.slick("slickPlay");
                            $(this).removeClass("icon-play").addClass("pause");
                            textNode.text(textNode.data("pause"));
                        };
                    });
                }
            });
        }
    },
    initRotatingImgsFailover: function() {
        var image = new Image();
        image.src = "/include/imager?opt=" + encodeURIComponent("w=400,h=600,scale=true") + "&src="
            + "/images/surly/gallery/2022/surly_disc_trucker_black_dale.jpg";
        $("#image-rotator").append(image);
    },
    initNav: function() {
        var _this = this, menuToggle = $("#menu-toggle"), sideNav = $("#side-nav"), galNav = $(".gallery-menu"), mozNav = false;
        menuToggle.on("click", function(e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).toggleClass("on");
            if ($(this).hasClass("on")) {
                sideNav.show().scrollTop(1);
            } else {
                setTimeout(function() {sideNav.hide();}, 350);
            };
            sideNav.toggleClass("open");
        }).on("closeMenu", function() {
            if ($(this).hasClass("on")) $(this).trigger("click");
        });

        sideNav.on("click", function(e) {
            e.stopPropagation();
        }).on("scroll", function() {
            if ($(this).scrollTop() == 0) {
                $(this).scrollTop(1);
            } else if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
                $(this).scrollTop($(this).scrollTop() - 1);
            }
        }).on("keydown", function(e) {
            var key = e.keyCode || e.which;
            if (key === 27) {
                $(".side-menu-close").trigger("click");
            };
        });

        $(".side-menu-close").on("click", function(e) {
            e.preventDefault();
            menuToggle.trigger("closeMenu").focus();
        }).on("keydown", function(e) {
            var key = e.keyCode || e.which;
            if (key === 9) {
                e.preventDefault();
                $(this).trigger("click");
            };
        });

        $("body").on("click", function(e) {
            menuToggle.trigger("closeMenu");
        });
        /*
        $(window).scroll(function() {
            if (mozNav) {
                var scTop = $(this).scrollTop();
                sideNav.css("top",scTop);
            }
        }).trigger("scroll");

        if (_this.isMoz) {
            $(window).resize(function() {
                if ($(window).width() >= 1800) {
                    mozNav = true;
                    sideNav.add(galNav).css({"position":"absolute"});
                } else {
                    mozNav = false;
                    sideNav.add(galNav).removeAttr("style");
                }
            }).trigger("resize");
        }*/

        var mainMenu = $("#topnav-links");

        // set mobile nav
        mainMenu.clone().attr("id","mnav-links").insertBefore("#mnav-sublinks");

        // set mobile subnav
        $("#mnav-links > li a").each(function() {
            var mSubnav = $(this).attr("data-subnav");
            if (mSubnav) {
                $("#"+mSubnav).clone().attr("id","m-"+mSubnav).insertAfter(this).wrap("<div class='msubnav-ctn'></div>");
            }
        });

        $("#m-bike-brands .logos .sr-only").removeClass("sr-only");

        var mnavLinks = sideNav.find("#mnav-links"), curPath = document.location.pathname;

        mnavLinks.on("click", "[data-subnav]", function(e) {
            e.preventDefault();
            $(this).toggleClass("open").parent().siblings().find("a").removeClass("open");
        }).on("click", ".msubnav-ctn a", function() {
            var $link = $(this).attr("href");

            if ($link.substr(0, $link.indexOf("#")) == curPath) {
                menuToggle.click();
            }
        });

        $("#hours-hdr-m").on("click", function() {
            $(this).toggleClass("open");
            $("#hours-info").slideToggle();
        });

        // subnav
        var subnavController = $("[data-subnav]"), subnav = $("#site-subnav"),
            subnavCnt = $(".subnav-content"),  curTarget, panelId;
        subnavController.hover(function(e) {
            $(this).trigger("showSubNav").trigger("expandable");
        }, function() {
            $(this).trigger("hideSubNav").trigger("expandable");
        });

        // Main menu items
        subnavController.on("showSubNav", function(e) {
            panelId = $(this).attr("data-subnav");
            subnavCnt.removeClass("open");
            $("#"+panelId).add(subnav).addClass("open");
            curTarget = e.currentTarget;
        }).on("hideSubNav", function() {
            if (curTarget.id != "site-subnav") {
                $("#"+panelId).add(subnav).removeClass("open");
            }
        });

        // Down arrow icon
        $(".menu-control").on("click", function() {
            var controller = $(this).siblings("[data-subnav]");
            if (controller.attr("aria-expanded") == "false") {
                controller.trigger("showSubNav").trigger("expandable");
            } else {
                controller.trigger("hideSubNav").trigger("expandable");
            };
        }).on("keydown", function(e) {
            var code = e.keyCode || e.which;
            // Tab key -> move focus to subnav's first link
            if (($(this).attr("aria-expanded") == "true") && (code === 9)) {
                e.preventDefault();
                var controller = $(this).siblings("[data-subnav]").attr("data-subnav");
                $("#"+controller).find("a").first().focus();
            }
        });

        subnav.hover(function(e) {
            //curTarget = e.currentTarget;
            $(curTarget).addClass("hover");
            $("#"+panelId).add(subnav).addClass("open");
        }, function() {
            $(this).add(subnavCnt).removeClass("open");
            $(curTarget).removeClass("hover");

        });

        // Escape key on submenu
        subnavCnt.on("keydown", function(e) {
            var code = e.keyCode || e.which;
            if (code === 27) {
                var controller = $(this).attr("id");
                var el = $("button[aria-controls='"+ controller +"']:visible");
                //console.log("escape!!", el);
                el.trigger("click").focus();
            };
        });

        $(".submenu-close").on("click", function(e) {
            e.preventDefault();
            var controller = $(this).closest(".subnav-content").attr("id");
            var el = $("button[aria-controls='"+ controller +"']:visible");
            el.trigger("click").focus();
        }).on("keydown", function(e) {
            var key = e.keyCode || e.which;
            if (key === 9) {
                e.preventDefault();
                $(this).trigger("click");
            };
        });
    },
    initMap: function() {
        if (!this.mapInitialized) {
            (g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
                key: "AIzaSyB7LIXEMw4XXw4F-kd5Qp5GPubCMT1eUq4",
                v: "quarterly",
            });

            let map;

            async function initGoogleMap() {
                // Request libraries when needed, not in the script tag.
                const { Map } = await google.maps.importLibrary("maps");
                const { PlacesService } = await google.maps.importLibrary("places");
                const { Marker } = await google.maps.importLibrary("marker");

                var styles = [
                    {
                        stylers: [
                            { hue: "#54add1" },
                            { saturation: -20 }
                        ]
                    }, {
                        featureType: "road",
                        elementType: "geometry",
                        stylers: [
                            { hue: "#f7941d" },
                            { saturation: 20 }
                        ]
                    }, {
                        featureType: 'water',
                        stylers: [
                            { color: '#2c5570' }
                        ]
                    }
                ];
                var styledMap = new google.maps.StyledMapType(styles, {name: "Styled Map"});

                map = new Map(document.getElementById("map-canvas"), {
                    center: { lat: 34.1077426, lng: -118.5916799 },
                    zoom: 11,
                });

                map.mapTypes.set('map_style', styledMap);
                map.setMapTypeId('map_style');

                var infowindow = new google.maps.InfoWindow();
                var placeService = new PlacesService(map);
                
                var request = {
                    placeId: 'ChIJXW0A41mfwoARic_JqAZaBYU'
                };

                placeService.getDetails(request, function(place, status) {
                    if (status == google.maps.places.PlacesServiceStatus.OK) {
                        var marker = new Marker({
                            map: map,
                            position: place.geometry.location
                        });
                        var contentString = '<h2 id="map-info-hdr">' + place.name + '</h2>' +
                            '<address>' + place.vicinity + '</address>';

                        google.maps.event.addListener(marker, 'mouseover', function() {
                            infowindow.setContent(contentString);
                            infowindow.open(map, this);
                        });
                    }
                });
            }

            var mapAddy = $("#gmap-addy"), mapIcon = mapAddy.find("span"), t;
            mapAddy.on("click", function() {
                var gmap = $("#gmap");
                clearTimeout(t);
                mapIcon.removeClass("ani");
                $(this).add(gmap).toggleClass("open");
                if (gmap.hasClass("open")) {
                    $("html, body").animate({
                        scrollTop: $(this).offset().top
                    },500);
                }
            }).one("click", function() {
                initGoogleMap();
            }).hover(function() {
                if (!$(this).hasClass("open") && !mapIcon.hasClass("ani")) {
                    mapIcon.addClass("ani");
                    t = setTimeout(function() {
                        mapIcon.removeClass("ani");
                    }, 5000);
                }
            });
            this.mapInitialized = true;
        }
    },
    initAccordion: function() {
        var accord = $("dl.faq");
        $("dt", accord).on("click", function() {
            $(this).toggleClass("open").next("dd").slideToggle(300);
        });
    },
    formValidation: function() {
        var contactForm = $(".contact-form"), signupForm = $("#mc-embedded-subscribe-form");
        var _this = this;

        $("[required]", contactForm).on("keypress", function() {
            if ($(this).attr("aria-invalid") == "true") {
                var errDiv = $(this).attr("aria-describedby");
                $("#" + errDiv).remove();
                $(this).attr("aria-invalid", "false").removeAttr("aria-describedby");
            }
        });

        contactForm.add(signupForm).on("submit", function(e) {
            var eType = $(this).data("type"), validated = true;
            e.preventDefault();
            $(".error", $(this)).remove();
            contactForm.removeClass("validated");
            $(this).find(".message-response").empty();

            $.each($('[required]', $(this)), function() {
                var errId = "err-" + $(this).attr("id");
                if ($.trim($(this).val()) == "") {
                    $(this).attr({"aria-invalid": "true", "aria-describedby": errId}).after('<p id="' + errId + '" class="error">This field is required.</p>');
                    validated = false;
                } else if ($(this).attr("pattern") !== undefined) {
                    var pat = new RegExp($(this).attr("pattern"));
                    if (!pat.test($(this).val())) {
                        $(this).attr({"aria-invalid": "true", "aria-describedby": errId}).after('<p id="' + errId + '" class="error">Input is not valid. Please try again.</p>');
                        validated = false;
                    } else {
                        $(this).attr("aria-invalid", "false");
                    }
                } else {
                    $(this).attr("aria-invalid", "false");
                }
            });
            
            if (validated) {
                contactForm.addClass("validated");
                if (eType == "contact") {
                    $("#contact-submit").addClass("loading");
                    grecaptcha.execute();
                } else if (eType == "signup") {
                    dataLayer.push({
                        'event': 'emailFormSubmission',
                        'formId': $(this).attr("id")
                    });
                    _this.submitEmailSignup($(this));
                };
            } else {
                if (eType == "contact") {
                    var errDiv = $("#form-err");
                    errDiv.html("<p class='error'>Please check the error(s) below to continue.</p>").focus();
                    $("html, body").animate({
                        scrollTop: errDiv.offset().top
                    },700);
                } else {
                    return false;
                };
            };
        });

        var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.pdf|\.doc|\.docx)$/i;
        contactForm.find("[type='file']").on("change", function() {
            var uFiles = this.files;
            var errId = "err-" + $(this).attr("id");
            for (var i = 0; i < uFiles.length; i++) {
                if (!allowedExtensions.exec(uFiles[i].name)) {
                    this.value = null;
                    $(this).attr({"aria-invalid": "true", "aria-describedby": errId}).after('<p id="' + errId + '" class="error">Sorry, we only accept the following file formats: jpg, jpeg, png, gif, pdf, doc, and docx.</p>');
                    return false;
                } else {
                    $("#" + errId).remove();
                }
            }
        });
    },
    submitEmailSignup: function(el) {
        var resp = el.find(".message-response").empty();
        $.ajax({
            type: "POST",
            url: el.attr("action"),
            data: new FormData(el.get(0)),
            contentType: false,
            cache: false,
            processData: false,
            dataType: "json",
            success: function(data) {
                if (data.success === "true") { 
                    dataLayer.push({
                        'event': 'emailSignup',
                        'formId': el.attr("id")
                    });
                } else {
                    dataLayer.push({
                        'event': 'emailSignupError',
                        'formId': el.attr("id"),
                        'errType': data.message.errCode
                    });
                };
                if (data.message) {
                    resp.html('<p class="success">' + data.message + '</p>').fadeIn(800);
                }
            },
            error: function() {
                var msg = '<p class="err-msg">Oops! Something went wrong and your message did not go through. Please try again later.</p>' + '500 error';
                $("#message-response").html(msg).fadeIn(800);
                dataLayer.push({
                    'event': 'emailSignupError',
                    'formId': el.attr("id"),
                    'errType': '500 error'
                });
            }
        }).always(function() {
            $("#contact-submit").removeClass("loading");
        });
    },
    initMasonry: function() {
        var gallery = $(".gal-container").not(".no-masonry"), articles = $(".article-grid");
        jQueryBridget('masonry', Masonry, $);
        if (gallery.length) {
            var $grid = gallery.masonry(this.masonryOpt);
            $grid.imagesLoaded().progress( function() {
                $grid.masonry('layout');
            });

            if (gallery.hasClass("lazygal-container")) {
                this.initInfiniteScroll($grid);
                if ($("#gal-filter").length) this.initGalleryFilter($grid);
            }
        }
        if (articles.length) {
            var $grid = articles.masonry(this.masonryOpt);
            $grid.imagesLoaded().progress( function() {
                $grid.masonry('layout');
            });
        }
        $(document).on("masonryLayout", function() {
            $grid.masonry('layout');
        });
    },
    initBikeGallery: function() {
        var brandGallery = $("#brand-gallery");
        if (brandGallery.length && brandGallery.hasClass("lazyload")) {
            // force page to scroll to top when reloaded. This forces lazyloading to work properly.
            if (history.scrollRestoration) {
                history.scrollRestoration = 'manual';
            } else {
                window.onbeforeunload = function () {
                    window.scrollTo(0, 0);
                }
            }

            brandGallery.find(".lazyimg").each(function(index) {
                var image = this;

                if (image.dataset) {
                    if (image.dataset.src) {
                        image.src = image.dataset.src;
                    }
                    if (image.dataset.srcset) {
                        image.srcset = image.dataset.srcset;
                    }
                }
                image.classList.remove("lazyimg");
            });

            var galImages = brandGallery.find("img"),
                galImgCount = (galImages.length > 20) ? 20 : galImages.length,
                imgLoaded = 0;
            galImages.on("load", function() {
                imgLoaded++;
                if (imgLoaded == galImgCount) {
                    $(document).trigger("masonryLayout");
                }
            });
        };
    },
    initBikeGalleryFailover: function() {
        var lazyloadThrottleTimeout;
        var brandGallery = document.querySelector("#brand-gallery");
        var lazyloadImages = brandGallery.querySelectorAll(".lazyimg");
        
        if (lazyloadImages) {
            // force page to scroll to top when reloaded. This forces lazyloading to work properly.
            if (history.scrollRestoration) {
                history.scrollRestoration = 'manual';
            } else {
                window.onbeforeunload = function () {
                    window.scrollTo(0, 0);
                }
            }

            function lazyload() {
                if (lazyloadThrottleTimeout) {
                    clearTimeout(lazyloadThrottleTimeout);
                }    
        
                lazyloadThrottleTimeout = setTimeout(function() {
                    var scrollTop = window.pageYOffset;

                    if (brandGallery.offsetTop < (window.innerHeight + scrollTop)) {
                        lazyloadImages.forEach(function(img) {
                            if (img.dataset) {
                                if (img.dataset.src) {
                                    img.src = img.dataset.src;
                                }
                                if (img.dataset.srcset) {
                                    img.srcset = img.dataset.srcset;
                                }
                            }
                            img.classList.remove('lazyimg');
                        });
                        document.removeEventListener("scroll", lazyload);
                        window.removeEventListener("resize", lazyload);
                        window.removeEventListener("orientationChange", lazyload);
                    }
                }, 20);
            }
            document.addEventListener("scroll", lazyload);
            window.addEventListener("resize", lazyload);
            window.addEventListener("orientationChange", lazyload);
        }
    },
    initInfiniteScroll: function($grid) {
        var gallery = $(".lazygal-container");
        var msnry = $grid.data('masonry');
        
        InfiniteScroll.imagesLoaded = imagesLoaded;
        jQueryBridget('infiniteScroll', InfiniteScroll, $);

        if ($("#gal-nav .next").length) {
            gallery.infiniteScroll({
                navSelector  : "#gal-nav", // selector for the paged navigation (it will be hidden)
                path : "#gal-nav .next", // selector for the NEXT link (to page 2)
                append : ".grid-item",  // selector for all items you'll retrieve
                scrollThreshold: 200,
                prefill: true,
                history: false,
                outlayer: msnry
            });

            gallery.on('append.infiniteScroll', function(event) {
                imagesLoaded(gallery.get(0), function() {
                    msnry.layout();
                });
            });
        };
    },
    initGalleryFilter: function($grid) {
        var _this = this, galFilterP = $("#gal-filter-p");
        var galFilterForm = $("#gal-filter-form"), galFilterCheckboxes = $("[name='bikeModels']", galFilterForm);
        var galFilterToggle = $("#show-filter-toggle"), allModelsCheckbox = $("#f-allm");
        var galContainer = $(".lazygal-container");
        galFilterToggle.on("click", function(e) {
            e.preventDefault();
            galFilterP.toggleClass("show");
        });
        $("#filter-apply .close-me").on("click", function() {
            galFilterToggle.trigger("click");
        });
        galFilterCheckboxes.on("change", function() {
            (galFilterCheckboxes.filter(":checked").length == 0) ? allModelsCheckbox.prop("checked", true) : allModelsCheckbox.prop("checked", false);
        });
        allModelsCheckbox.on("change", function() {
            if ($(this).is(":checked")) galFilterCheckboxes.prop("checked", false);
        });
        $("#gal-filter-reset").on("click", function() {
            allModelsCheckbox.prop("checked", true).trigger("change");
        });
        $("#gal-filter-apply").on("click", function() {
            var filterNames = [], url, urlAjax;
            var filterList = galFilterForm.find("input:checked").map(function() {
                filterNames.push("<li>" + this.dataset.modelName + "</li>");
                return this.value;
            }).get().join();
            //console.log(filterList);
            if (filterList != "") {
                url = location.pathname + "?model=" + filterList;
                urlAjax = url + "&load=true";
            } else if (location.search.indexOf("model") > 0) {
                url = location.pathname;
                urlAjax = url + "?load=true";
            };
            if (typeof url != "undefined") {
                $.ajax({
                  url: urlAjax
                }).done(function( html ) {
                    var jHtml = $(html);
                    var galContent = jHtml.find("#brand-gallery .grid-item");
                    var galNav = jHtml.find("#gal-nav li");
                    if (galContainer.data('infiniteScroll')) galContainer.infiniteScroll("destroy");
                    $grid.masonry("remove", galContainer.find(".grid-item"));
                    $grid.masonry().append(galContent).masonry("appended", galContent);
                    $grid.imagesLoaded( function() {
                        $grid.masonry('layout');
                    });
                    $("#gal-nav").html(galNav);
                    if ($("#gal-nav .next").length) _this.initInfiniteScroll($grid);
                    history.pushState(null, null, url);
                    $("#gal-filter-list").html(filterNames.join(""));
                });
            };
            $("#filter-apply .close-me").click();
        });
    },
    initFancybox: function() {
        var fbox = $("[data-fancybox]");
        if (fbox.length) {
            var fbOptions = {
                buttons: [
                "zoom",
                "slideShow",
                "thumbs",
                "close"
              ],
              afterShow: function( instance, current ) {
                  //console.log("FBOX aftershow")
                  $("#rjvid").trigger("stopMe");
              },
              beforeClose : function( instance, current, e ) {
                  $("#rjvid").trigger("startMe");
              }
            };

            try {
                fbox.fancybox(fbOptions);
            } catch (err) {
                //console.log("load Fancybox script");
                $.getScript("/assets/fancybox/jquery.fancybox3.min.js", function() {
                    fbox.fancybox(fbOptions);
                    //_this.runPromo();
                });
                $('<link/>', {
                    rel: 'stylesheet',
                    type: 'text/css',
                    href: '/assets/fancybox/jquery.fancybox3.min.css'
                }).appendTo('head');
            }
        };

        //var fbox = $(".fbox"), vbox = $(".fvidbox"), forceLoad = true, _this = this;
        //if (fbox.length || vbox.length || forceLoad) {
            /*
            var fbSettings = {
                padding: 0,
                helpers		: {
                    title	: { type : 'outside' },
                    overlay: {
                        closeClick : true,
                        showEarly : true,
                        css	: {
                            'background': 'rgba(0,0,0,.85)'
                        },
                    locked: false
                    }
                },
                beforeLoad: function() {
                    this.title = $(this.element).find("img").attr("alt");
                }
            };

            try {
                fbox.fancybox(
                    fbSettings
                );
                vbox.fancybox({
                    padding: 0,
                    openEffect  : 'none',
                    closeEffect : 'none',
                    helpers : {
                        media : {}
                    }
                });
            } catch (err) {
                $.getScript("/assets/fancybox/jquery.fancybox.pack.js", function() {
                    $.getScript("/assets/fancybox/helpers/jquery.fancybox-media.js", function() {
                        fbox.fancybox(
                            fbSettings
                        );
                        vbox.fancybox({
                            padding: 0,
                            openEffect  : 'none',
                            closeEffect : 'none',
                            helpers : {
                                media : {}
                            }
                        });
                        _this.runPromo();
                    });
                });
                $('<link/>', {
                    rel: 'stylesheet',
                    type: 'text/css',
                    href: '/assets/fancybox/jquery.fancybox.css'
                }).appendTo('head');
            }*/

            /*
            $("a.fvidbox").click(function() {
                $.fancybox({
                'padding'		: 0,
                'autoScale'		: false,
                'transitionIn'	: 'none',
                'transitionOut'	: 'none',
                'title'			: this.title,
                    'overlayColor'		: '#000',
                    'overlayOpacity'	: 0.85,
                'width'		: 780,
                'height'		: 426,
                'href'			: this.href.replace(new RegExp("watch\\?v=", "i"), 'v/'),
                'type'			: 'swf',
                'swf'			: {
                     'wmode'		: 'transparent',
                         'allowfullscreen'	: 'true'
                    }
                });
                return false;
            });

            $('.iframe').fancybox({
                'padding'		: 0,
                'autoScale'		: false,
                'transitionIn'	: 'none',
                'transitionOut'	: 'none',
                'title'			: this.title,
                    'overlayColor'		: '#000',
                    'overlayOpacity'	: 0.85,
                'width'		: 780,
                'height'		: 426
            });
            */
		//}
    },
    util: function() {
        if (!this.isMobile) {
            $(".add-hover, .ani-img").hover(function() {
                $(this).toggleClass("hover");
            }, function() {
                $(this).toggleClass("hover");
            });
        }
        /*
        $(".hero-banner.slickme").on("mouseout", function() {
            try{
                $(this).slick("slickPlay");
            } catch(err) {
            };
        });*/
    },
    initMagellanMenu: function() {
        var magellanMenu = $("#magellan-nav");
        var closeMagMenu = function(el) {
            if (el.classList.contains("m-trigger")) {
                magellanMenu.addClass("open");
            } else {
                magellanMenu.removeClass("open");
            };
        };

        if (Foundation.MediaQuery.is('small only') && magellanMenu.length) {
            magellanMenu.on("click", ".m-trigger", function(e) {
                magellanMenu.addClass("open");
            });
            document.body.addEventListener("click", function(e) {
                closeMagMenu(e.target);
            });
            document.body.addEventListener("touchmove", function(e) {
                closeMagMenu(e.target);
            });
        };
    },
    initMagellanGallery: function() {
        var lazyTarget = $("[data-lazyload-target]");
        if (lazyTarget.length) {
            var _this = this, lazyGal = $("[data-gallery='lazyload']"), galTop = lazyTarget.offset().top;
            var wHeight = $(window).height();

            $(window).on("scroll", function() {
                if ($(this).scrollTop() > (galTop - wHeight)) {
                    $(this).trigger("loadLazyGallery");
                }
            }).one("loadLazyGallery", function() {
                lazyGal.each(function() {
                    var $this = $(this), url = "/include/lazyload_gallery";
                    var options = {
                        title: $(this).data("title"),
                        count: $(this).data("count"),
                        path: $(this).data("path")
                    }
                    $.get(url, options, function(result) {
                        $this.append(result);
                        _this.initMasonry();
                    });
                });
            });
        }
    },
    initArrows: function() {
        var topBanner = $("section.banner");
        if (topBanner.length) {
            $('<div class="arrow-bounce icon-angle-down"></div>').appendTo(topBanner).on("click", function() {
                var nextSection = $(this).parents("section").next("section, div");
                $("html, body").animate({
                    scrollTop: nextSection.offset().top - 40
                },700);
            });;
        }

        // back to top
        $('<div id="btt" class="icon-angle-up"><span class="sr-only">Back to top</span<</div>').appendTo("body").on("click", function() {
            $("html, body").animate({
                scrollTop: 0
            },400);
        });
        var btt = $("#btt"), bttOn = false, body = $("body");
        $(window).on("scroll", function() {
            var winScroll = $(this).scrollTop();

            if (winScroll > 12) {
                body.addClass("sticky-nav");
            } else {
                body.removeClass("sticky-nav");
            }

            if (winScroll > 600) {
                if (!bttOn) {
                    btt.fadeIn(400);
                    bttOn = true;
                }
            } else {
                if (bttOn) {
                    btt.fadeOut(400);
                    bttOn = false;
                }
            }
        });
    },
    initEventTracking: function() {
        $(".ev-inst").on("click", function() {
            ga('send', 'event', 'Instagram', 'click', 'Unpredict');
        });
    },
    initTripMenu: function() {
        var slidingNav = $("#gal-slide-menu");
        slidingNav.slick({
            slidesToShow: 6,
            slidesToScroll: 6,
            infinite: false,
            responsive: [
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 5
              }
            }]
        });
        var sNav = $(".sliding-nav");
        $("h3", sNav).on("click", function() {
            sNav.add(sNav.parent(".menu-wrapper")).toggleClass("open");
            if (slidingNav.length) {
                slidingNav.slick('setPosition').slick('slickGoTo',galIndex);
                slidingNav.find("li").eq(galIndex).addClass("active");
            }
        });
    },
    handleLazyImage: function(elm) {
        var images = (elm.tagName == "IMG") ? elm : (elm.tagName == "PICTURE") ? elm.querySelectorAll("source") : elm;

        images.forEach(function(image) {
            if (image.dataset.src) {
                image.src = image.dataset.src;
            }
            if (image.dataset.srcset) {
                image.srcset = image.dataset.srcset;
            }
        });
        elm.classList.remove("lazy");
        
    },
    handleLazyImageFailovers: function(elm) {
        var lazyloadThrottleTimeout;
        var images = (elm.tagName == "IMG") ? elm : (elm.tagName == "PICTURE") ? elm.querySelectorAll("source") : elm;
        var elmOffsetTop = $(elm).offset().top;
        
        function lazyload() {
            if (lazyloadThrottleTimeout) {
                clearTimeout(lazyloadThrottleTimeout);
            }    
            
            lazyloadThrottleTimeout = setTimeout(function() {
                var scrollTop = window.pageYOffset;

                if (elmOffsetTop < (window.innerHeight + scrollTop)) {
                    images.forEach(function(image) {
                        if (image.dataset.src) {
                            image.src = image.dataset.src;
                        }
                        if (image.dataset.srcset) {
                            image.srcset = image.dataset.srcset;
                        }
                    });
                    elm.classList.remove('lazy');
                    document.removeEventListener("scroll", lazyload);
                    window.removeEventListener("resize", lazyload);
                    window.removeEventListener("orientationChange", lazyload);
                }
            }, 20);
        }
        document.addEventListener("scroll", lazyload);
        window.addEventListener("resize", lazyload);
        window.addEventListener("orientationChange", lazyload);
    },
    initIGCarouselSlider: function() {
        var igCarousel = $("#ig-gallery-carousel");
        igCarousel.slick({
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            dots: false,
            responsive: [
            {
                breakpoint: 640,
                settings: {
                  slidesToShow: 2.5,
                  slidesToScroll: 2,
                  arrows: false,
                  dots: true
                }
              }]
        });
    },
    handleShopifyProducts(el) {
        var url = "/include/shopify_products", params = [];
        if ($(el).data("id")) {
            params.push("cid=" + $(el).data("id"));
        }
        if ($(el).data("max")) {
            params.push("max=" + $(el).data("max"));
        }
        if (params.length > 0) {
            url += "?" + params.join("&");
        }
        
        $.get(url, function(data) {
            if (data) {
                try {
                    var prodData = JSON.parse(data);
                    prodData.forEach((el, index) => {
                        $(`[data-ftprod-anchor-${index}]`).attr("href", el.url);
                        $(`[data-ftprod-img-${index}]`).attr("src", el.imgSrc);
                        $(`[data-ftprod-title-${index}]`).text(el.title);
                    });
                } catch(e) {
                    console.log("===> Product data error");
                }
            }
        });
    },
    handleInstaPosts(el) {
      var url = "include/instagram_feed_carousel_template";
      var _this = this;
      $.get(url, function(data) {
        if (data) {
            el = $(el);
            el.html(data);
            _this.initIGCarouselSlider();
            el.find("[data-intersection]").each(function() {
                _this.pageObserver.observe(this);
            });
        }
      });
    },
    showGear: function() {
        if (this.isPhone && Foundation.MediaQuery.is("small only")) {
            $("#touring-br li").on("click", function() {
                $(this).siblings("li").removeClass("active");
                $(this).addClass("active");
            });
            $("#touring-br > li:first-child").trigger("click");
        }
    },
    pageJump: function() {
        if (location.hash.length > 0) {
            var tagId = location.hash.slice(1);
            var jumpTo = $("[data-tag='" + tagId + "']");

            if (jumpTo.length) {
                $("html, body").animate({
                    scrollTop: jumpTo.offset().top
                }, 500);
            }
        }
    },
    runPromo: function() {
        var promoActive = false, promoImg = "/assets/images/home/tax_day_sale_2016_promo.jpg";
        var promoStatus = sessionStorage.getItem('promo2Shown');
        if (promoActive && !promoStatus) {
            $.fancybox.open({href : promoImg, title : ''});
            sessionStorage.setItem('promo2Shown', 'true');
        }
    },
    globalStuff: function() {
        var _this = this;
        $(window).on("click", function(e) {
            if ((!$(e.target).closest("#gal-slide-nav").length) && (!$(e.target).closest("#bike-menu").length)) {
                var sNav = $(".sliding-nav");
                sNav.add(sNav.parent(".menu-wrapper")).removeClass("open");
            }
        });

        $(".open-map").on("click", function(e) {
            e.preventDefault();
            if (typeof google !== "undefined" && google.maps) {
                $("#gmap-addy").click();
            } else {
                _this.initMap();
                setTimeout(function() {
                    $("#gmap-addy").click();
                }, 0);
            }
        });

        if (typeof sitePopup !== 'undefined') {
            openDialog(sitePopup.url, sitePopup.cookieName, sitePopup.cookieExp);
        }
    },
    manageAcc: function() {
        var expandables = $("[aria-expanded]");
        expandables.on("expandable", function() {
            var controlled = $(this).attr("aria-controls");
            //console.log("controlled", controlled);
            if ($(this).attr("aria-expanded") == "true") {
                $(this).attr("aria-expanded", "false");
                if (controlled) $("#" + controlled).attr({"aria-hidden": "true"});
            } else {
                $(this).attr("aria-expanded", "true");
                if (controlled) $("#" + controlled).attr({"aria-hidden": "false"});
            };
        }).on("click", function() {
            $(this).trigger("expandable");
        });
    },
    initInterchange: function() {
        var isWebp = $("html").hasClass("webp"),
            webpInterchange = $("[data-webp-interchange]");

        webpInterchange.each(function() {
            try {
                var interchangeRule = [];
                var imgData = JSON.parse($(this).attr("data-webp-interchange"));
                $.each(imgData, function(key, value) {
                    if (isWebp) {
                        var webpFile = value.replace(/\.[^/.]+$/, ".webp");
                        interchangeRule.push("[" + webpFile + ", " + key + "]");
                    } else {
                        interchangeRule.push("[" + value + ", " + key + "]");
                    }
                });
                //console.log(interchangeRule.toString());
                
                var interchange = new Foundation.Interchange($(this), {
                    rules: interchangeRule
                });

            } catch(error) {
                console.log(error);
            }
        });
        if (webpInterchange.length > 0) {
            $(window).on('changed.zf.mediaquery resize.zf.mediaquery',function(){
                webpInterchange.foundation('_reflow');
            });
        }
    },
    createModal: function() {
        $("[data-modal-url]").on("click", function(e) {
            e.preventDefault();
            var promoWin = $("#promo-win");

            if (!promoWin.length) {
                var targetUrl = $(this).attr("data-modal-url");
                //console.log("----------> ", targetUrl);
                if (targetUrl) {
                    $.get(targetUrl, function(data) {
                        $("body").append(data);
                        promoWin = $("#promo-win");
                        var promoReveal = new Foundation.Reveal(promoWin);
                        
                        promoWin.foundation('open');
                        promoWin.on("click", ".close-reveal-modal", function() {
                            promoWin.foundation('close');
                        });
                    });
                }
            } else {
                promoWin.foundation('open');
            }
            
        });

    },
    checkCookie: function(cookiename) {
        var cookieExist = this.getCookie(cookiename);
        if (cookieExist != "") {
            return cookieExist;
        }
        return false;
    },
    getCookie: function(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    /* setCookie("cookiename", cookieExist, COOKIE_EXPIRY_TIME);
    // example - setCookie("username", cookieExist, (0.5 * 60 * 1000)); this cookie expires in 30 seconds.
    // the cookie expiry time have to be in seconds so convert your time in seconds and after that pass it.
    */
    setCookie: function(cname, cvalue, exdays) {
        var expires = "";
        if (exdays !== null) {
            var d = new Date();
            d.setTime(d.getTime() + exdays);
            expires = d.toGMTString();
        }
        document.cookie = cname + "=" + cvalue + ";expires=" + expires + ";path=/";
    }
}

$(function() {
    gb.init();
});

var openDialog = function(url ,cookieName, cookieExp) {
    var popCheck = (arguments[3] == true) ? true: !gb.getCookie(cookieName);
    var waitTime = 6000;

    if (popCheck) {
        setTimeout(function() {
            $.get(url, function(data) {
                $("body").append(data);
                var promoWin = $("#promo-win");
                var promoReveal = new Foundation.Reveal(promoWin);
                
                promoWin.foundation('open');
                promoWin.on("click", ".close-reveal-modal", function() {
                    promoWin.foundation('close');
                });
                gb.setCookie(cookieName, "true", (Number(cookieExp) > 0) ? 1000*60*60*24*cookieExp : null);
            });
        }, waitTime);
    }
}

/*
$(document).foundation({
    "magellan-expedition": {
        threshold: 0, // how many pixels until the magellan bar sticks, 0 = auto
        destination_threshold: 0, // pixels from the top of destination for it to be considered active
        throttle_delay: 50, // calculation throttling to increase framerate
        fixed_top: 0, // top distance in pixels assigend to the fixed element on scroll
        offset_by_height: false // whether to offset the destination by the expedition height. Usually you want this to be true, unless your expedition is on the side.
    }
});
*/

function onMsgSubmit() {
    console.log('xxxxxxxx calling onMsgSubmit');
    $.ajax({
        type: "POST",
        url: "/include/send_message",
        data: new FormData($(".contact-form").get(0)),
		contentType: false,
		cache: false,
		processData: false,
        dataType: "json",
        success: function(data) {
            if (data.success) {
                var msg = '<p class="success-msg">';
                if (data.message.alert) msg += '<strong>** ' + data.message.alert + ' **</strong><br />';
                msg += data.message.body + '</p>';
                dataLayer.push({
                    'event': 'contactFormSubmission',
                    'formId': $(".contact-form").attr("id")
                });
            } else {
                var msg = '<p class="err-msg">';
                msg += data.message.body + '</p>';
                if (data.message.errCode) console.log("error: " + data.message.errCode);
                dataLayer.push({
                    'event': 'contactFormSubmissionError',
                    'formId': $(".contact-form").attr("id"),
                    'errType': data.message.errCode
                });
            };
            $("#message-response").html(msg).fadeIn(800);
            grecaptcha.reset();
        },
        error: function() {
            var msg = '<p class="err-msg">Oops! Something went wrong and your message did not go through. Please try again later.</p>' + '500 error';
            $("#message-response").html(msg).fadeIn(800);
            dataLayer.push({
                'event': 'contactFormSubmissionError',
                'formId': $(".contact-form").attr("id"),
                'errType': '500 error'
            });
        }
    }).always(function() {
        $("#contact-submit").removeClass("loading");
    });
}

window.onMsgSubmit = onMsgSubmit;
